import React from 'react';
import { connect } from 'react-redux';
import { Header } from '../../features/header/Header';
import { Footer } from '../../features/footer/Footer';
import RequiredFileFormatSelector from '../IngestPage/RequiredFileFormatSelector';
import styled from 'styled-components';
import { DatePicker } from '../../common/components';
import { Link } from 'react-router-dom';
import { UploadCard, Paginator } from './components';
import config from '../../config';
import { formatUploadHeaderDate } from '../../common/formatters';
import { StatusCode } from '../../features/uploads/uploadsActions';
import { withAuthentication } from '../../common/authentication';
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { download } from '../../features/uploads/uploadsMiddleware';

const ITEMS_PER_PAGE = config.uploadsItemsPerPage;
const FilterType = {
  FileName: 1,
  FromDate: 2,
  ToDate: 3,
  UploadOutcome: 4,
};
const PickerLabel = styled(Label)``;

class UploadsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pages: 0,
      currentPage: 0,
      uploadOutcomeFilter: '',
      filter: {
        fromDate: null,
        toDate: null,
        fileName: '',
        outcome: null,
        filterFn: () => true,
      },
    };
  }

  componentDidMount() {
    this.props.getUploads(this.props.authState.accessToken);
  }

  handleFilterInput(value, filterType) {
    const filter = this.state.filter;
    switch (filterType) {
      case FilterType.FileName:
        filter.fileName = value;
        break;
      case FilterType.FromDate:
        filter.fromDate = value;
        break;
      case FilterType.ToDate:
        filter.toDate = value;
        break;
      case FilterType.UploadOutcome:
        filter.outcome = value;
        break;
      default:
        break;
    }

    const doFilter = (record) =>
      (filter.fromDate == null ? true : record.uploadDate >= filter.fromDate) &&
      (filter.toDate == null ? true : record.uploadDate <= filter.toDate) &&
      (filter.outcome == null
        ? true
        : record.uploadSucceeded === filter.outcome) &&
      (filter.fileName == null || filter.fileName === ''
        ? true
        : record.fileName.toLowerCase().indexOf(filter.fileName.toLowerCase()) >
          -1);

    this.setState({
      filter: { ...filter, filterFn: doFilter },
      currentPage: 0,
    });
  }
  createUpload(upload) {
    return (
      <Row className="mb-3" key={upload.ingestId}>
        <Col>
          <UploadCard
            token={this.props.authState.accessToken}
            upload={upload}
            filter={this.state.filter}
            onMoreDetails={() => {
              this.props.openUploadDetails(upload);
            }}
            onPreview={
              () => {
                this.props.getDetails(
                  upload.ingestId,
                  this.props.authState.accessToken,
                );
              } /*UploadsStore.loadDetails*/
            }
            onDownloadLogs={() => {
              this.props.downloadLogs(upload);
            }}
            downloadError={() => {
              this.props.downloadError(upload);
            }}
          />
        </Col>
      </Row>
    );
  }

  deleteItem() {
    this.props.deleteUpload(
      this.props.delete,
      this.props.authState.accessToken,
    );
  }

  handleOutcomeFilter(checked, outcome) {
    let outcomeState = null;
    if (!checked) {
      outcomeState = null;
    } else if (checked && outcome === 'FAILED') {
      outcomeState = false;
    } else if (checked && outcome === 'SUCCEEDED') {
      outcomeState = true;
    } else if (checked && outcome === 'ALL') {
      outcomeState = null;
    }

    this.handleFilterInput(outcomeState, FilterType.UploadOutcome);
  }

  renderState() {
    const { status } = this.props;
    switch (status) {
      case StatusCode.Loading:
        return (
          <div style={{ textAlign: 'center', paddingBottom: '1em' }}>
            <span>Loading...</span>
            <div>
              <Spinner />
            </div>
          </div>
        );

      default:
        const records = this.props.records.filter(this.state.filter.filterFn);
        const pages = Math.ceil(records.length / ITEMS_PER_PAGE);
        const currentPage = this.state.currentPage;
        return records && records.length > 0 ? (
          <>
            {records
              .slice(
                currentPage * ITEMS_PER_PAGE,
                currentPage * ITEMS_PER_PAGE + ITEMS_PER_PAGE,
              )
              .map((r) => this.createUpload(r))}
            <Row className="justify-content-sm-end">
              <div>
                {pages > 1 && (
                  <Paginator
                    onPage={(page) => {
                      this.setState({ currentPage: page });
                      window.scroll && window.scroll(0, 0);
                    }}
                    pages={pages}
                    current={currentPage}
                  />
                )}
              </div>
            </Row>
          </>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <h4 className="mb-5 p-5">No Uploads Found</h4>
          </div>
        );
    }
  }

  /**
   * Used to reset pending delete item, and clearing of filters
   * @param {*} props
   * @param {*} state
   */
  static getDerivedStateFromProps(props, state) {
    if (state.prevProps !== props) {
      return { ...state, delete: null, prevProps: props, currentPage: 0 };
    }
    return state;
  }

  render() {
    return (
      <>
        <Header />
        <Container>
          <h2 className="mb-4">Your Uploads</h2>
          <div>
            <Form>
              <Row className="mb-4 align-items-center justify-content-center">
                <Col>
                  <FormGroup>
                    <PickerLabel className="tpicap-label">
                      Uploaded From
                    </PickerLabel>
                    <DatePicker
                      onChange={(value) =>
                        this.handleFilterInput(value, FilterType.FromDate)
                      }
                      value={this.state.filter.fromDate}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <PickerLabel className="tpicap-label">
                      Uploaded To
                    </PickerLabel>
                    <DatePicker
                      onChange={(value) =>
                        this.handleFilterInput(value, FilterType.ToDate)
                      }
                      value={this.state.filter.toDate}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <PickerLabel className="tpicap-label">&nbsp;</PickerLabel>
                    <Input
                      className="form-control-sm"
                      placeholder="Search filenames"
                      type="text"
                      value={this.state.filter.fileName}
                      onChange={(e) =>
                        this.handleFilterInput(
                          e.target.value,
                          FilterType.FileName,
                        )
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md="auto">
                  <FormGroup check>
                    <Label check>
                      <Input
                        className="mt-2 mr-2"
                        type="radio"
                        name="radioOutcome"
                        onChange={(e) =>
                          this.handleOutcomeFilter(e.target.checked, 'FAILED')
                        }
                      />
                      Failed
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input
                        className="mt-2 mr-2"
                        type="radio"
                        name="radioOutcome"
                        onChange={(e) =>
                          this.handleOutcomeFilter(
                            e.target.checked,
                            'SUCCEEDED',
                          )
                        }
                      />
                      Succeeded
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input
                        className="mt-2 mr-2"
                        type="radio"
                        name="radioOutcome"
                        onChange={(e) =>
                          this.handleOutcomeFilter(e.target.checked, 'ALL')
                        }
                        defaultChecked
                      />
                      All Uploads
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </div>
          <Row className="mb-4">
            <Col md="auto" className="mr-auto"></Col>
            <RequiredFileFormatSelector
              className="mr-2"
              bepFlag={config.bepActiveFlag}
              fepSpotFlag={config.fepSpotActiveFlag}
              fepForwardsFlag={config.fepForwardsActiveFlag}
              fepNonLinearFlag={config.fepNonLinearActiveFlag}
            />
            <Col md="auto">
              <Button tag={Link} to="/upload" className="btn-cta">
                Upload Transactions File
              </Button>
            </Col>
          </Row>
          {this.renderState()}
          {this.props.delete != null && (
            <Modal isOpen>
              <ModalHeader>
                {this.props.delete.error
                  ? 'Delete Error'
                  : 'Delete Confirmation'}
              </ModalHeader>
              {this.props.delete.error ? (
                <ModalBody>
                  Error Deleting{' '}
                  <span style={{ fontWeight: 'bold' }}>
                    {this.props.delete.upload.fileName}
                  </span>
                </ModalBody>
              ) : (
                <ModalBody>
                  Are you sure you want to delete fileName{' '}
                  <span style={{ fontWeight: 'bold' }}>
                    {this.props.delete.upload.fileName}
                  </span>{' '}
                  {`uploaded on ${formatUploadHeaderDate(
                    this.props.delete.upload.uploadDate,
                  )}`}
                </ModalBody>
              )}
              {this.props.delete.error ? (
                <ModalFooter style={{ padding: '1em' }}>
                  <Button
                    color="primary"
                    onClick={() => this.props.cancelDelete()}
                  >
                    Close
                  </Button>
                </ModalFooter>
              ) : (
                <ModalFooter style={{ padding: '1em' }}>
                  <Button
                    color="primary"
                    onClick={() => this.props.cancelDelete()}
                  >
                    No, Keep File
                  </Button>
                  <Button color="danger" onClick={() => this.deleteItem()}>
                    Yes, Delete
                    {this.props.delete &&
                      this.props.delete.status === 'progress' && (
                        <span style={{ paddingLeft: '1em' }}>
                          <Spinner size="sm" />
                        </span>
                      )}
                  </Button>
                </ModalFooter>
              )}
            </Modal>
          )}
          {this.props.openuploaddetails != null && (
            <Modal isOpen>
              <ModalHeader>
                {this.props.openuploaddetails.upload.fileName}
              </ModalHeader>
              <ModalBody>
                <Container>
                  <Row>
                    <Col md="auto" className="mr-auto">
                      <Label className="tpicap-label-lowercase">
                        Upload Date:
                      </Label>
                      {formatUploadHeaderDate(
                        this.props.openuploaddetails.upload.uploadDate,
                      )}
                      <Label className="tpicap-label-lowercase">
                        Upload Agent:
                      </Label>
                      {this.props.openuploaddetails.upload.uploadAgent}
                      <Label className="tpicap-label-lowercase">
                        Number of Rows:
                      </Label>
                      {this.props.openuploaddetails.upload.rows}
                      <Label className="tpicap-label-lowercase">
                        Number of Columns:
                      </Label>
                      {this.props.openuploaddetails.upload.cols}
                    </Col>
                    <Col md="auto" className="mr-auto">
                      <Label className="tpicap-label-lowercase">
                        Number of Rows with Errors:
                      </Label>
                      {this.props.openuploaddetails.upload.validationErrorCount}
                      <Label className="tpicap-label-lowercase">
                        Number of File Level Errors:
                      </Label>
                      {this.props.openuploaddetails.upload.fileLevelErrorCount}
                      <Label className="tpicap-label-lowercase">
                        Number of Potential Duplicates:
                      </Label>
                      {this.props.openuploaddetails.upload.duplicateCount}
                    </Col>
                  </Row>
                  <Row>&nbsp;</Row>
                  <Row>&nbsp;</Row>
                  <Row>
                    <Label className="tpicap-label">Actions:</Label>
                  </Row>
                  <Row>&nbsp;</Row>
                  <Row>
                    <Col className="d-flex justify-content-evenly">
                      <Button
                        className="tpicap-thin-outline-button-modal mx-auto"
                        size="sm"
                        color="default"
                        outline
                        onClick={() => {
                          this.setState({ isDownloading: true });
                          download(
                            this.props.openuploaddetails.upload,
                            this.props.token,
                          ).then(() => {
                            this.setState({ isDownloading: false });
                          });
                        }}
                      >
                        Download File
                        {this.state.isDownloading && (
                          <span style={{ paddingLeft: '1em' }}>
                            <Spinner size="sm" />
                          </span>
                        )}
                      </Button>
                    </Col>
                    <Col className="d-flex justify-content-evenly">
                      <Button
                        className="tpicap-thin-outline-button-modal mx-auto"
                        size="sm"
                        color="default"
                        outline
                        onClick={() => {
                          this.props.stageDelete(
                            this.props.openuploaddetails.upload,
                          );
                        }}
                      >
                        Delete Upload
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </ModalBody>
              <ModalFooter style={{ padding: '1em' }}>
                <Button
                  color="primary"
                  onClick={() => this.props.closeUploadDetails()}
                >
                  Close
                </Button>
              </ModalFooter>
            </Modal>
          )}
          {this.props.downloaderror != null && (
            <Modal isOpen>
              <ModalHeader>Download Unavailable</ModalHeader>
              <ModalBody>
                The logs files for this upload are not available to download.
              </ModalBody>
              <ModalFooter style={{ padding: '1em' }}>
                <Button
                  color="primary"
                  onClick={() => this.props.closeDownloadError()}
                >
                  Close
                </Button>
              </ModalFooter>
            </Modal>
          )}
        </Container>
        <Footer />
      </>
    );
  }
}

export default connect((globalState) => globalState.uploads, {
  getUploads: (token) => ({
    type: 'uploads/getuploads',
    payload: { token: token },
  }),
  getDetails: (ingestId, token) => ({
    type: 'uploads/getdetails',
    payload: { ingestId, token },
  }),
  openUploadDetails: (upload) => ({
    type: 'uploads/openuploaddetails',
    payload: upload,
  }),
  closeUploadDetails: () => ({
    type: 'uploads/closeuploaddetails',
  }),
  downloadLogs: (upload) => ({
    type: 'uploads/downloadlogs',
    payload: upload,
  }),
  deleteUpload: (upload, token) => ({
    type: 'uploads/delete',
    payload: { upload, token },
  }),
  downloadError: (upload) => ({
    type: 'uploads/downloaderror',
    payload: upload,
  }),
  closeDownloadError: () => ({
    type: 'uploads/closedownloaderror',
  }),
  stageDelete: (upload) => ({ type: 'uploads/stagedelete', payload: upload }),
  cancelDelete: () => ({ type: 'uploads/canceldelete' }),
})(withAuthentication(UploadsPage));
